// @flow
import React from "react";
import classnames from "classnames";
import { Grid, Header, Icon, Loader } from "semantic-ui-react";

import Styles from "./ShortOfferForm.module.scss";
import { LoginOrRegister } from "Commons/Modules/auth/components/LoginOrRegister/LoginOrRegister";
import { MODES } from "Commons/Modules/auth/components/LoginOrRegister/misc/modes";
import { signUpLoginPage } from "Commons/Utilities/GoogleTagManager";

type PropsT = {
  t: Function,
  handleAuthenticate?: Function,
  showSpinner?: boolean,
  stackButtons?: boolean,
  lite?: boolean,
  onRegister?: Function,
  gtmEvent?: string,
};

let RegisterStep = function RegisterStep({ t, stackButtons, showSpinner, lite, onRegister, gtmEvent }: PropsT) {
  const [actuallyShowSpinner, setShowSpinner] = React.useState(showSpinner);

  React.useEffect(() => {
    signUpLoginPage("ShortOfferForm");
  }, []);

  React.useEffect(() => {
    if (actuallyShowSpinner) {
      setTimeout(() => setShowSpinner(false), 3000);
    }
  }, [actuallyShowSpinner]);

  if (actuallyShowSpinner) {
    return (
      <div>
        <div className={Styles["wait-block-text"]}>{t("blogArticleUnfolding:wizard.registerPage.dataIsProcessed")}</div>
        <Loader active className={Styles["wait-block-spinner"]} />
      </div>
    );
  }

  return (
    <>
      <Grid centered divided>
        <Grid.Column width={lite ? 16 : 12}>
          <LoginOrRegister
            flags={{ regLightWsFlag: true, gtmEvent }}
            onAuthenticate={onRegister}
            mode={MODES.FUNNEL}
            submitButtonText={t("blogArticleUnfolding:wizard.registerPage.form.submit")}
            basic
            header={{
              funnel: (
                <>
                  <Header as="h5" className={Styles.title}>
                    <Icon name={"check"} className={classnames(Styles["lite-header-icon"], "theme-color-primary")} />
                    <Header.Content className={Styles["lite-header-text"]}>
                      {t("blogArticleUnfolding:wizard.registerPage.header")}
                    </Header.Content>
                  </Header>
                  <div className={Styles.subtitle}>{t("blogArticleUnfolding:wizard.registerPage.funnel.subTitle")}</div>
                </>
              ),
              register: (
                <>
                  <Header as="h5" className={Styles.title}>
                    <Icon name={"check"} className={classnames(Styles["lite-header-icon"], "theme-color-primary")} />
                    <Header.Content className={Styles["lite-header-text"]}>
                      {t("blogArticleUnfolding:wizard.registerPage.header")}
                    </Header.Content>
                  </Header>
                  <div className={Styles.subtitle}>
                    {t("blogArticleUnfolding:wizard.registerPage.register.subTitle")}
                  </div>
                  <h5 className={Styles.withMargin}>{t("blogArticleUnfolding:wizard.registerPage.register.title")}</h5>
                </>
              ),
              login: (
                <>
                  <Header as="h5" className={Styles.title}>
                    <Icon name={"check"} className={classnames(Styles["lite-header-icon"], "theme-color-primary")} />
                    <Header.Content className={Styles["lite-header-text"]}>
                      {t("blogArticleUnfolding:wizard.registerPage.header")}
                    </Header.Content>
                  </Header>
                  <div className={Styles.subtitle}>{t("blogArticleUnfolding:wizard.registerPage.login.subTitle")}</div>
                  <h5 className={Styles.withMargin}>{t("blogArticleUnfolding:wizard.registerPage.login.title")}</h5>
                </>
              ),
            }}
          />
        </Grid.Column>
      </Grid>
    </>
  );
};

export default RegisterStep;
